export default [
    {
        path: '/product/price-extension/create',
        props: true,
        component: () => import('@/views/Product/PriceExtension/Create'),
    },
    {
        path: '/product/price-extension',
        props: true,
        component: () => import('@/views/Product/PriceExtension'),
    },
    {
        path: '/product/price-extension/:id',
        props: true,
        component: () => import('@/views/Product/PriceExtension/Show'),
    },
];
